"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.extractAirportFilterParams = extractAirportFilterParams;
exports.extractAllFiltersParams = extractAllFiltersParams;
exports.extractFilterParams = extractFilterParams;
exports.extractFlightFilterParams = extractFlightFilterParams;
exports.extractFlightMaxStopFilterParams = extractFlightMaxStopFilterParams;
exports.extractFlightStopFilterParams = extractFlightStopFilterParams;
exports.extractFlightTimeFilterParams = extractFlightTimeFilterParams;
exports.extractMultiSelectFilterParams = extractMultiSelectFilterParams;
exports.extractNestedMultiSelectFilterParams = extractNestedMultiSelectFilterParams;
exports.extractSingleSelectFilterParams = extractSingleSelectFilterParams;
exports.generateMultiSelectFilterParams = generateMultiSelectFilterParams;
exports.generateSingleSelectFilterParams = generateSingleSelectFilterParams;
var _each2 = _interopRequireDefault(require("lodash/each"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _split2 = _interopRequireDefault(require("lodash/split"));
var _range2 = _interopRequireDefault(require("lodash/range"));
var _constants = require("../constants");
function extractFlightFilterParams(_ref) {
  var totalPrice = _ref.totalPrice,
    legs = _ref.legs,
    hasInsuranceCoverage = _ref.hasInsuranceCoverage,
    hasBaggageOnly = _ref.hasBaggageOnly,
    isFlex = _ref.isFlex;
  var filterParams = {
    airline: [],
    airport: [],
    price: totalPrice,
    stop: extractFlightStopFilterParams(legs),
    maxStop: extractFlightMaxStopFilterParams(legs),
    departureTime: [],
    arrivalTime: [],
    insuranceOnly: hasInsuranceCoverage,
    hasBaggageOnly: hasBaggageOnly,
    isFlex: isFlex
  };
  (0, _each2.default)(legs, function (leg) {
    var originId = leg.originId,
      destinationId = leg.destinationId,
      departureHour = leg.departureHour,
      arrivalHour = leg.arrivalHour,
      validatingCarrier = leg.validatingCarrier;
    filterParams.airline.push(validatingCarrier);
    filterParams.airport.push((0, _join2.default)([originId, destinationId], _constants.FILTER_PARAM_AIRPORT_SEPARATOR));
    filterParams.departureTime.push(extractFlightTimeFilterParams(departureHour));
    filterParams.arrivalTime.push(extractFlightTimeFilterParams(arrivalHour));
  });
  return filterParams;
}
function extractFlightStopFilterParams(legs) {
  var stopCount = (0, _max2.default)((0, _map2.default)(legs, function (leg) {
    return leg.stopCount;
  }));
  return stopCount > 2 ? 2 : stopCount;
}
function extractFlightMaxStopFilterParams(legs) {
  return (0, _max2.default)((0, _map2.default)(legs, function (leg) {
    return leg.stopCount;
  }));
}
function extractFlightTimeFilterParams(hour) {
  var timeSegment = (0, _find2.default)(_constants.TIME_FILTER_SEGMENTS, function (_ref2) {
    var from = _ref2.from,
      to = _ref2.to;
    return from <= hour && to >= hour;
  });
  return (0, _get2.default)(timeSegment, 'code', _constants.TIME_FILTER_SEGMENTS.AM.code);
}
function extractAllFiltersParams(filtersState) {
  var filtersParams = {};
  (0, _each2.default)(filtersState, function (filterState, filterKey) {
    filtersParams[filterKey] = extractFilterParams(filterKey, filterState);
  });
  return filtersParams;
}
function extractFilterParams(filterKey, filterState) {
  switch (filterKey) {
    case 'airline':
      return extractMultiSelectFilterParams(filterState);
    case 'airport':
      return extractAirportFilterParams(filterState);
    case 'price':
      return filterState;
    case 'stop':
      return extractMultiSelectFilterParams(filterState);
    case 'maxStop':
      return extractSingleSelectFilterParams(filterState);
    case 'departureTime':
      return extractNestedMultiSelectFilterParams(filterState);
    case 'arrivalTime':
      return extractNestedMultiSelectFilterParams(filterState);
    case 'insuranceOnly':
      return filterState;
    case 'hasBaggageOnly':
      return filterState;
    case 'isFlex':
      return filterState;
    default:
      return {};
  }
}
function extractMultiSelectFilterParams(filterState) {
  var activeFilterState = (0, _filter2.default)(filterState, 'selected');
  return (0, _map2.default)(activeFilterState, 'code');
}
function extractSingleSelectFilterParams(filterState) {
  var activeFilterState = (0, _filter2.default)(filterState, 'selected');
  return activeFilterState.length > 0 && activeFilterState.length < filterState.length ? (0, _range2.default)((0, _max2.default)((0, _map2.default)(activeFilterState, 'code')) + 1) : [];
}
function extractNestedMultiSelectFilterParams(filterState) {
  return (0, _map2.default)(filterState, function (legFilterState) {
    return extractMultiSelectFilterParams(legFilterState);
  });
}
function extractAirportFilterParams(filterState) {
  return (0, _map2.default)(filterState, function (legFilterState) {
    var origin = extractMultiSelectFilterParams(legFilterState.origin);
    var destination = extractMultiSelectFilterParams(legFilterState.destination);
    return {
      origin: origin,
      destination: destination
    };
  });
}
function generateMultiSelectFilterParams(filterQuery) {
  if (typeof filterQuery !== 'string' || filterQuery === _constants.FILTER_PARAM_ALL_ITEM) return [];
  return (0, _split2.default)(filterQuery, _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR);
}
function generateSingleSelectFilterParams(filterQuery) {
  if (typeof filterQuery !== 'string' || filterQuery === _constants.FILTER_PARAM_ALL_ITEM) return [];
  return [(0, _max2.default)((0, _split2.default)(filterQuery, _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR))];
}
var _default = exports.default = extractAllFiltersParams;